<template>
  <!-- <main-area> -->
    <div class="homePage">
      <div class="bannerBgc">
        <div class="pagew bg">
        </div>
      </div>
      <div class="banner_bootom" v-if="false">
        <div class="text">
          <img
            src="@/assets/image/didi.png"
            alt=""
            style="margin-right: 10px"
            width="30px"
            height="30px"
          />
        </div>
        <div>2022创客广东大赛开赛！</div>
      </div>
      <!-- 新闻部分 -->
      <div class="pagew announcement">
        <div class="pagew bar-title">
          <div class="imgbox">
            <img src="../../assets/image/index/event-bar.png" />
          </div>
          <h2 style="margin-top: 36px">赛事公告</h2>
        </div>
        <div class="announcement_content">
          <div class="announcement_introduction">
            <img src="../../assets/image/index/mainintrodution.jpg" alt="">
          </div>
          <div class="announcement_text">
            <div class="news-box">
              <div class="texts" v-for="(item, index) in hotList" :key="index"><news :item="item"></news></div>
            </div>
          </div>
        </div>
      </div>
      <!-- 新闻部分 -->
      <div class="pagew announcement">
        <div class="pagew bar-title">
          <div class="imgbox">
            <img src="../../assets/image/index/news-bar.png" />
          </div>
          <h2 style="margin-top: 36px">新闻报道</h2>
        </div>
        <div class="announcement_content">
          <div class="announcement_text">
            <div class="news-box">
              <div class="texts" v-for="(item, index) in newsList" :key="index"><news :item="item"></news></div>
            </div>
          </div>
          <div class="announcement_introduction">
            <img src="../../assets/image/index/mainnews.jpg" alt="">
          </div>
        </div>
      </div>
      <Footer :show="true" />
    </div>
  <!-- </main-area> -->
</template>

<script>
import MainArea from "@/components/MainArea";
import news from "./components/news.vue";
import {getNewsList} from "@/api/api.js";
export default {
  components: { MainArea, news },
  data() {
    return {
      activeName: "LogoCanvas",
      carHeight: '400px',
      workList: [
        {}, {}, {}
      ],
      hotList: [],
      newsList: [],
      timeline: [
        {id: '1', name: '第一届', t: '2005'},
        {id: '2', name: '第二届', t: '2022'},
        {id: '3', name: '第三届', t: '2022'},
        {id: '4', name: '第四届', t: '2022'},
        {id: '5', name: '第五届', t: '2022'},
        {id: '6', name: '第六届', t: '2022'},
        {id: '7', name: '第七届', t: '2022'},

        {id: '8', name: '第八届', t: '2022'},
        {id: '9', name: '第九届', t: '2022'},
        {id: '10', name: '第十届', t: '2022'},
        {id: '11', name: '第十一届', t: '2022'},
        {id: '12', name: '第十二届', t: '2022'},
        {id: '13', name: '第十三届', t: '2022'},
        {id: '14', name: '第十四届', t: '2022'},
        {id: '15', name: '第十五届', t: '2022'},
        {id: '16', name: '第十六届', t: '2022'},
        {id: '17', name: '第十七届', t: '2022'},
      ].reverse(),
      flexArr: [
        {
          title: "主赛道",
          img: require("@/assets/image/zhusaidao.png"),
        },
        {
          title: "港澳台创新设计对接赛",
          img: require("@/assets/image/duijie.png"),
        },
        {
          title: "企业设计命题专项赛",
          img: require("@/assets/image/zhuanti.png"),
        },
      ],
      judgesArr: [
        {
          name: "张三",
          url: require("@/assets/image/pingwei.png"),
          introduction: "他是张三他是张三他是张三他是张三他是张三他是张三他是张三他是张三他是张三他是张三他是张三他是张三",
        },
        {
          name: "赵四",
          url: require("@/assets/image/goodbit.png"),
          introduction: "他是赵四",
        },
        {
          name: "王五",
          url: require("@/assets/image/zhuban2.png"),
          introduction: "他是王五",
        },
        {
          name: "李六",
          url: require("@/assets/image/yin.png"),
          introduction: "他是李六",
        },
        {
          name: "赵四",
          url: require("@/assets/image/goodbit.png"),
          introduction: "他是赵四",
        },
        {
          name: "王五",
          url: require("@/assets/image/zhuban2.png"),
          introduction: "他是王五",
        },
        {
          name: "李六",
          url: require("@/assets/image/yin.png"),
          introduction: "他是李六",
        },
      ],
      translateY: 0,
      activeIndex: 0,
    };
  },
  created() {
    this.getNewsList();
    this.getNewsNewsList();


    const wwidth = (window.innerWidth / 1920) * 596;
    this.carHeight = `${Math.floor(wwidth)}px`;
  },
  methods: {
    onMoreWorks() {
      this.goWorkList();
    },
    goWorkList() {
      this.$router.push({
        path: "Work/list",
        query: {

        },
      });
    },
    goWork() {
      this.$router.push({
        path: "Work",
        query: {

        },
      });
    },
    goRoute(index) {
      this.$router.push({
        path: "/match",
        query: {pos: index}
      });
    },
    getNewsList() {
      getNewsList({pageNum: 1, pageSize: 4, type: 1}).then(res=>{
        const { total, rows = [] } = res.data;
        this.hotList = rows
      })
    },
    getNewsNewsList() {
      getNewsList({pageNum: 1, pageSize: 4, type: 2}).then(res=>{
        const { total, rows = [] } = res.data;
        this.newsList = rows
      })
    },
    onSelect(activeIndex) {
      this.activeIndex = activeIndex;
    },

    onDown() {
      // 8 展示8个
      const y = (this.timeline.length - 8) * 60;
      if (Math.abs(this.translateY) >= y) return;
      this.translateY -= 60;
    },

    onUp() {
      if (this.translateY >= 0) return;
      this.translateY += 60;
    },

    gotoNews() {
      // this.$router.push({
      //   path: "/news",
      // });

      const {href} = this.$router.resolve({
        path: "/news",
      });
      window.open(href, '_blank');
    },

    onMore() {
      const {href} = this.$router.resolve({
        path: "/Export",
      });
      window.open(href, '_blank');
    }
  },
};
</script>

<style lang="scss" scoped>
.homePage {
  // width: 1677px;
  .bannerBgc {
    z-index: -2;
    background: url('../../assets/image/index/index-banner.jpg') no-repeat center top;
    background-size: cover;

    // min-height: 660px;
    .bg {
      height: 600px;
      //background: url('../../assets/image/index-banner-main.jpg') no-repeat center top;
    }
  }
  .boxcontent {
    // width: 70%;
    text-align: center;
    display: flex;
    justify-content: space-around;
    margin: 0 auto;
    .stle {font-weight: 700;line-height: 30px;}
    .content {
      margin-top: -50px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 359px;height: 150px;
      background: url(../../assets/image/zhubootm.png) no-repeat center;
      .bgc {
        position: absolute;
        width: 359px;
        z-index: 0;
      }
      .content_text {
        z-index: 1;
      }
    }
  }
  .banner_bootom {
    background-color: rgb(249, 246, 237);
    width: 100%;
    height: 180px;
    margin-top: -50px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    padding-top: 50px;
  }
  .coloechange {
    width: 60%;
    margin: 0 auto;
    text-align: left;
    .cont {
      width: 100%;
      display: flex;
      .name {
        padding: 10px 0;
        width: 45%;
        text-align: right;
        margin-right: 65px;
        color: #c0c0c0;
        letter-spacing: 5px;
        font-size: 14px;
      }
      .linebox {
        padding: 10px 0;
        width: 38%;
        display: flex;
        justify-content: flex-end;
        .line {
          background-color: rgb(4, 79, 166);
          width: 95%;
          height: 15px;
          //margin-left: 80vw;
        }
      }
    }
  }
  .announcement {
    padding: 50px 0 30px;
    .announcement_content {
      display: flex;
      // align-items: center;
      justify-content: center;
      padding-top: 40px;
      .announcement_text {
        width: 540px;
        height: 400px;
        margin-left: 30px;

        .button {
          height: 36px;
          line-height: 36px;
          font-size: 14px;
          text-align: right;
        }
        .texts {
          width: 268px;
          height: 188px;
          overflow: hidden;
          border: 1px solid rgb(221, 221, 221);
          &:nth-child(2n+2) {
            border-left: none;
          }
          &:nth-child(1), &:nth-child(2) {
            border-bottom: none;
          }
        }
      }
    }
    .news-box {
      display: flex;
      flex-wrap: wrap;
      // justify-content: space-between;
    }
  }
  .announcement_introduction {width: 600px;height: 340px; margin-left: 30px}
  .announcement_introduction img{width: 100%}
  .announcement_video {width: 600px;height: 340x; margin-left: 30px}
  .judges {
    display: flex;
    // justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    .right {
      // margin-left: 400px;
      display: flex;
      // justify-content: space-around;
      // align-items: center;
      .right_img {
        margin-left: -100px;width: 324px;height: 350px;
      }
      .right_text {
        position: relative;
        width: 440px;
        margin-left: 56px;
        text-align: left;
        .semi {
          display: block;
          background: url('../../assets/image/yin.png') no-repeat right center;
          width: 45px;
          height: 45px;
        }
        .detail {
          margin-top: 50px;line-height: 22px;
          height: 140px;text-indent: 24px;
        }
        .more-btn {
          position: absolute;left: 0;bottom: 0;line-height: 30px;text-align: right;width: 100%;
        }
      }
    }
    .left {
      background-color: rgb(249, 246, 237);
      padding: 70px 200px 0 50px;
      height: 550px;
      box-sizing: border-box;
      .left_name {
        display: block;
        padding: 20px 0;line-height: 20px;
        padding-left: 50px;
        position: relative;
        &::before {
          content: '';
          width: 14px;height: 2px;overflow: hidden;background-color: #c7ad88;
          position: absolute;left: 0;top: 50%;transform: translateY(-50%);transition: all .25s;
        }
      }
      .left_name.selected {
        color: #044fa6;
        &::before {background-color: #044fa6;width: 30px;}
      }
    }
  }
  .good {
    display: flex;
    justify-content: center;
    align-items: center;
    .good_left {
      width: 810px;height: 668px;
    }
    .work-time-line {
      width: 562px;height: 100%;margin: auto;position: relative;
      // background: url('../../assets/image/index/work-logo.png') no-repeat center center;
      .times {
        position: absolute;font-size: 18px;line-height: 22px;transform: translate(-14px, 20px);
        &:hover, &.actived {
          color: #044fa6;
        }
      }
      .times1 { top: 60px;left: 242px;color: #044fa6;}
      .times2 { top: 120px;left: 358px;}
      .times3 { top: 180px;left: 422px;}

      .times4 { top: 240px;left: 442px;}
      .times5 { top: 300px;left: 442px;}
      .times6 { top: 360px;left: 442px;}

      .times7 { top: 440px;left: 422px;}
      .times8 { top: 500px;left: 352px;}

      .times9 { top: 550px;left: 242px;}
      .times10 { top: 500px;left: 120px;}
      .times11 { top: 440px;left: 80px;}
      .times12 { top: 360px;left: 60px;}

      .times13 { top: 300px;left: 60px;}
      .times14 { top: 240px;left: 60px;}

      .times15 { top: 180px;left: 60px;}
      .times16 { top: 120px;left: 60px;}
      .times17 { top: 60px;left: 60px;}
    }
    .good_right {
      // height: 600px;
      margin-left: 20px;text-align: right;;
      .more-btn {
        line-height: 20px;margin-bottom: 10px;display: inline-block;
      }
    }
    .works-img-box {
      display: flex;height: 600px; margin-top: 100px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .works-img {
        width: 395px;
      }
    }
  }
}
.left-name-list {
  .icon {display: block;font-size: 0;
    background-position: center center;
    width: 100%;height: 16px;
    background-repeat: no-repeat;
    background-image: url('../../assets/image/index/up.png');
  }
  .icon.down {
    background-image: url('../../assets/image/index/down.png');
  }
}
.scroll-list-box {
  height: 360px;overflow: hidden;position: relative;margin: 5px 0;
  .scroll-list {
    transition: all .25s;
  }
}
.img-title {
  text-align: center;
}
.index-img-icon {
  cursor: pointer;
}
.works-box {
  background: url('../../assets/image/works-bg.jpg') no-repeat center top;
}
.works-main {
  height: 1064px;
  background: url('../../assets/image/works-main.jpg') no-repeat center top;
  .left-name-list {
    width: 180px;padding-left: 270px;padding-top: 140px;
    .icon {display: block;font-size: 0;
      background-position: center center;
      width: 100%;height: 16px;
      background-repeat: no-repeat;
      background-image: url('../../assets/image/index/up.png');
    }
    .icon.down {
      background-image: url('../../assets/image/index/down.png');
    }
  }
  .scroll-list-box {
    height: 480px;overflow: hidden;position: relative;margin: 5px 0;
    .scroll-list {
      transition: all .25s;
    }
  }
  // works
  .left_name {
    display: block;
    padding: 20px 0;line-height: 20px;font-size: 15px;
    padding-left: 50px;
    position: relative;
    &::before {
      content: '';
      width: 22px;height: 4px;overflow: hidden;background-color: #c7ad88;border-radius: 4px;
      position: absolute;left: 0;top: 50%;transform: translateY(-50%);transition: all .25s;
    }
  }
  .left_name.selected {
    color: #044fa6;font-weight: 700;
    &::before {background-color: #044fa6;width: 40px;}
  }
}
.banner-text-box {top: 420px;}
// @media screen and (max-width: 1580px) {
//   .banner-text-box {
//     transform: translateX(-50%) scale(.8);
//     top: 180px;
//   }
// }
// @media screen and (max-width: 1280px) {
//   .banner-text-box {
//     transform: translateX(-50%) scale(.65);
//     top: 220px;
//   }
// }
.s-text-box-1 {
  position: absolute;width: 32%;height: 28%;top: 20%;left: 19%;
  background: rgba(228, 76, 88, .9);color: #fff;
  font-size: 36px;
}
.s-text-box-2 {
  position: absolute;width: 32%;height: 28%;top: 20%;left: 33%;
  background: rgba(228, 76, 88, .9);color: #fff;
  font-size: 36px;
}
.s-text-box-3 {
  position: absolute;width: 32%;height: 28%;top: 20%;left: 57%;
  background: rgba(228, 76, 88, .9);color: #fff;
  font-size: 36px;
}
.saidao-text {
  padding-top: 60px;
}
</style>
<style lang="scss">
  .carousel-box {
    // .el-carousel__container {height: auto;min-height: 300px;}
    .el-carousel__button {
      background: #c1c1c1;
    }
    .is-active .el-carousel__button {
      background: #044fa6;
    }
  }
  .homePage {
    .footerbox {margin-top: 0 !important;}
  }
</style>



// WEBPACK FOOTER //
// src/view/homePage/homePage.vue